export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_label_amzFirstDemandNo') || '需求单号',
    field: 'amzFirstDemandNo',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_title') || '需求标题',
    field: 'title',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_design') || '负责企划',
    field: 'designName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_operate') || '负责运营',
    field: 'operateName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_amzFirstDemandStatus') || '单据状态',
    field: 'amzFirstDemandStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'amzFirstDemandStatus' },
  },
  {
    title: that.$l('table_label_amzFtyPurchaseStatus') || '采购状态',
    field: 'amzFtyPurchaseStatus',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'amzFtyPurchaseStatus' },
  },
  {
    title: that.$l('table_label_skuSalesChannel') || '产品类型',
    field: 'v_skuSalesChannel',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'skuSalesChannel' },
  },
  {
    title: that.$l('table_label_createBy') || '创建人',
    field: 'createByName',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_createDate') || '创建时间',
    field: 'createDate',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_modifyBy') || '修改人',
    field: 'modifyByName',
    align: 'center',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_modifyDate') || '修改时间',
    field: 'modifyDate',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
